import { render } from "./BaseIcon.vue?vue&type=template&id=79f1831c&scoped=true"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"

import "./BaseIcon.vue?vue&type=style&index=0&id=79f1831c&scoped=true&lang=css"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f1831c"]])

export default __exports__